import React from 'react'

function SelectedItem({ isFolder, type, status, adType, name, onClick }) {
  return (
    <div className='w-100 px-2 py-2 d-flex align-items-center gap-2
     rounded border border-dashed border-info text-primary
     user-select-none cursor-pointer
     '
     style={{height: "37px"}}
     onClick={onClick}
     >
      {isFolder ? // Folder
        <span className="avatar-title w-auto rounded bg-transparent text-primary fs-3">
          <i className="ri-folder-line lh-1"></i>
        </span>
      : type ? // Feed - Status / true - false
        status === true ?
          <span className="avatar-title w-auto rounded bg-transparent text-info fs-3">
            <i className="mdi mdi-rss lh-1"></i>
          </span>
        :
          <span className="avatar-title w-auto rounded bg-transparent text-danger fs-3">
            <i className="mdi mdi-rss lh-1"></i>
          </span>
      : adType ?
          <span class="avatar-title w-auto rounded bg-transparent text-body">
            <svg id="Group_5" data-name="Group 5" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 22.222 20">
              <defs>
                <rect id="Rectangle_2" data-name="Rectangle 2" width="22.222" height="20" fill="#212529"/>
              </defs>
              <g id="Group_4" data-name="Group 4">
                <path id="Path_13" data-name="Path 13" d="M14.444,14.444h4.444V10H17.778v3.333H14.444ZM3.333,7.778H4.444V4.444H7.778V3.333H3.333ZM6.944,20V17.778H1.667a1.6,1.6,0,0,1-1.167-.5A1.6,1.6,0,0,1,0,16.111V1.667A1.6,1.6,0,0,1,.5.5,1.6,1.6,0,0,1,1.667,0H20.556a1.6,1.6,0,0,1,1.167.5,1.6,1.6,0,0,1,.5,1.167V16.111a1.709,1.709,0,0,1-1.667,1.667H15.278V20ZM1.667,16.111H20.556V1.667H1.667Zm0,0v0Z" fill="#212529"/>
              </g>
            </svg>
          </span>
      : null}
      <p className='m-0'>Move <b>{name}</b> here</p>
    </div>
  )
}

export default SelectedItem
